import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Moment from "moment";
import Typography from "material-ui-next/Typography";
import { Row, Col } from "react-flexbox-grid";
import { CNPJ } from "cpf_cnpj";

import { DatePicker, EntitySelector } from "components/support";
import style from "./style";

class Filter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: {
        ...props.filters,
        company: { name: "", uuid: "" }
      },
      changeIndicator: true
    };
  }

  handleChange({ startDate, endDate }) {
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    this.setState(prevState => ({
      filters: { ...prevState.filters, ...options }
    }));
  }

  handleClose() {
    const { onChange } = this.props;

    this.setState(
      prevState => ({ changeIndicator: !prevState.changeIndicator }),
      () => onChange(this.state.filters)
    );
  }

  onSelectCompany = value => {
    const { onChange } = this.props;
    this.setState(
      prevState => ({ filters: { ...prevState.filters, company: value } }),
      () => onChange(this.state.filters)
    );
  };

  render() {
    const { className, companySearchOptions } = this.props;
    const { filters } = this.state;
    const { company } = filters;
    const { dateFrom, dateTo } = filters;

    return (
      <div className={className}>
        <Paper elevation={1} className="pv-sm">
          <Typography type="title" className="filter-title pl-sm">
            Filtro
          </Typography>
          <Row bottom="xs" className="pl-sm pt-sm">
            <Col xs={12} md>
              <Typography type="subheading" className="filter-title pl-sm">
                Período
              </Typography>
              <DatePicker
                fullWidth
                multiple
                noMargin
                modal
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
                onClose={() => this.handleClose()}
              />
            </Col>
            <Col xs={12} md>
              <EntitySelector
                allowClear
                fullWidth
                label="Empresa"
                title="Selecionar Empresa"
                value={company.name}
                searchOptions={companySearchOptions}
                onSelect={company => this.onSelectCompany(company)}
                parser={company => ({
                  key: company.uuid,
                  title: company.slug,
                  subtext: company.fiscal_informations
                    ? CNPJ.format(company.fiscal_informations.cnpj)
                    : ""
                })}
                nullSelection={{ name: "", uuid: "" }}
              />
            </Col>
          </Row>
        </Paper>
      </div>
    );
  }
}

export default style(Filter);



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/filter/index.js